import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Container from '../../../elements/Container'
import P from '../../../elements/Typo/P'
import Text from '../../../elements/Typo/Text'

import Icon from '../../../components/icons'
import Dropdown from '../../../elements/Form/dropdown'
import { MeasurementTabTypes } from '../../../_config/types'
import { useExperimentSelector } from '../../../store/selectors/experimentSelector'
import { trackEvent } from '../../../_common/functions'

interface Props {
    tab: MeasurementTabTypes
}

const MeasurementHeader: React.FC<Props> = ({ tab }) => {
    const { t } = useTranslation()
    const experiment: any = useExperimentSelector()
    const [step, setStep] = useState<any>(0)

    useEffect(() => {
        if (tab == 'data') {
            setStep(0)
        }
        if (tab == 'filter') {
            setStep(1)
        }
        if (tab == 'configure') {
            setStep(2)
        }
    }, [tab])

    const getStepClass = (step: any, targetStep: any) => {
        if (step > targetStep) {
            return 'bg-primary text-secondary'
        } else if (step === targetStep) {
            return 'bg-secondary text-primary'
        } else {
            return 'bg-white text-secondary'
        }
    }

    return (
        <Container size="md" className="my-4">
            <div className="flex items-center justify-center">
                <P className="font-semibold !mb-0">{t('Measurement Experiment')}</P>
            </div>

            <div className="mt-4 mb-2 flex justify-between items-center border-2 border-primary rounded-[0.833rem] px-9 py-[0.833rem]">
                <div className={`flex items-center p-[0.833rem] gap-2`}>
                    <div className={`flex items-center justify-center rounded-sm w-6 h-6  ${getStepClass(step, 0)}`}>{step > 0 ? <Icon name="check" size={0.833} /> : 1}</div>
                    <div>
                        <Text size="sm" className="font-semibold">
                            {t('Selection')}
                        </Text>
                        <Text size="sm" className="text-[#464E5F]">
                            {t('Select the Relevant Measurement Data')}
                        </Text>
                    </div>
                </div>

                <div className={`flex items-center p-[0.833rem] gap-2 ${step < 1 ? 'bg-[#f1f1f1] rounded-[0.833rem]' : ''}`}>
                    <div className={`flex items-center justify-center rounded-sm w-6 h-6 font-semibold ${getStepClass(step, 1)}`}>{step > 1 ? <Icon name="check" size={0.833} /> : 2}</div>
                    <div>
                        <Text size="sm" className="font-semibold">
                            {t('Set Scope')}
                        </Text>
                        <Text size="sm" className="text-[#464E5F]">
                            {t('Set Filters for Experiment Measurement')}
                        </Text>
                    </div>
                </div>
                <div className={`flex items-center p-[0.833rem] gap-2 ${step < 3 ? 'bg-[#f1f1f1] rounded-[0.833rem]' : ''}`}>
                    <div className={`flex items-center justify-center rounded-sm w-6 h-6 font-semibold ${getStepClass(step, 2)}`}>{step == 3 ? <Icon name="check" size={0.833} /> : 3}</div>
                    <div>
                        <Text size="sm" className="font-semibold">
                            {t('Configure Measurement')}
                        </Text>
                        <Text size="sm" className="text-[#464E5F]">
                            {t('Finalize Experiment Configuration and Measure Results')}
                        </Text>
                    </div>
                </div>
            </div>

            {experiment == null && (
                <div className="flex justify-end">
                    <div className="flex items-center gap-4">
                        <Text size="sm">{t('Select an existing experiment from the dropdown to prefill the fields automatically :')}</Text>

                        <div className="min-w-[15rem]">
                            <Dropdown
                                value={null}
                                onChange={(selected: any) => {
                                    trackEvent('measurement_experiment_selected', { experiment_literal: selected?.experiment_literal, experiment_type: selected?.experiment_type?.title })
                                }}
                                options={[]}
                            />
                        </div>
                    </div>
                </div>
            )}
        </Container>
    )
}

export default MeasurementHeader
